import { createContext } from 'react';
export var TiptapEditorContext = createContext(undefined);
//# sourceMappingURL=TiptapEditorContext.js.map